// import React, { useState } from "react";
// import { GetParcelsInPark } from "../../CommonData/CommonData";
// import { ParkList } from "../../PreRenderedComponents";
// import { IPDCReportTemplate } from "../../../../../components";
// import { Grid, CircularProgress, Button } from "@mui/material";
// import { Search } from "@mui/icons-material";
// import useDecodedUser from "../../../../../services/hooks/useDecodedUser";

// export default function ParcelList() {
//   const [data, setData] = useState([]);
//   const [selectedPark, setSelectedPark] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const decodedUser = useDecodedUser();
//   const fetchParcelsInPark = async () => {
//     try {
//       setLoading(true);
//       if (selectedPark) {
//         let tempParcel = await GetParcelsInPark(selectedPark?.id, false);
//         //remove geometry from parcel
//         const filteredParcel = tempParcel?.map(({ geometry, ...rest }) => rest);
//         //console.log(filteredParcel);
//         filteredParcel && filteredParcel?.length > 0
//           ? setData(filteredParcel)
//           : setData([]);
//       }
//       setLoading(false);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   if (loading) return <CircularProgress />;
//   return (
//     <>
//       <Grid container className="no-print" spacing={2} ml={1} mb={2}>
//         <Grid item xs={12} md={6}>
//           <ParkList
//             selectedPark={selectedPark}
//             setSelectedPark={setSelectedPark}
//           />
//         </Grid>
//         <Grid item xs={12} md={3}>
//           <Button
//             startIcon={<Search />}
//             onClick={fetchParcelsInPark}
//             variant="contained"
//             color="primary"
//             fullWidth={true}
//           >
//             Search
//           </Button>
//         </Grid>
//       </Grid>
//       <>
//         {data && data?.length > 0 ? (
//           <IPDCReportTemplate
//             data={data}
//             setData={setData}
//             defaultTitle="Parcels List"
//             isEditable={false}
//             isPrintable={false}
//             showWhatToDisplay={true}
//           />
//         ) : (
//           <div>No Investor</div>
//         )}
//       </>
//     </>
//   );
// }
import React, { useState, useEffect } from "react";
import { GetParcelsInPark } from "../../CommonData/CommonData";
import { IPDCReportTemplate } from "../../../../../components";
import { Grid, CircularProgress, Button } from "@mui/material";
import { Search } from "@mui/icons-material";
import useDecodedUser from "../../../../../services/hooks/useDecodedUser";

export default function ParcelList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const decodedUser = useDecodedUser();

  // Helper function to flatten nested objects
  const flattenObject = (obj, parentKey = '', result = {}) => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        const newKey = parentKey ? `${parentKey}_${key}` : key;
        
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
          flattenObject(obj[key], newKey, result);
        } else if (Array.isArray(obj[key])) {
          result[newKey] = JSON.stringify(obj[key]);
        } else {
          result[newKey] = obj[key];
        }
      }
    }
    return result;
  };

  // Helper function to process all parcels
  const processParcelsData = (parcels) => {
    return parcels.map(parcel => {
      // Create a copy without geometry
      const { geometry, ...rest } = parcel;
      
      // Flatten any nested objects
      const flattened = {};
      for (let key in rest) {
        if (rest.hasOwnProperty(key)) {
          if (typeof rest[key] === 'object' && rest[key] !== null && !Array.isArray(rest[key])) {
            // If it's an object like {fee, rate_type, currency}, convert to string
            flattened[key] = JSON.stringify(rest[key]);
          } else if (Array.isArray(rest[key])) {
            flattened[key] = JSON.stringify(rest[key]);
          } else {
            flattened[key] = rest[key];
          }
        }
      }
      return flattened;
    });
  };

  const fetchParcelsInPark = async () => {
    try {
      setLoading(true);
      console.log("USERRRRRRRRRRRRRRRRRRRR", decodedUser?.park_id);
      
      if (decodedUser?.park_id) {
        console.log("PARK :", decodedUser.park_id);
        let tempParcel = await GetParcelsInPark(decodedUser.park_id, false);
        
        // Remove geometry and flatten nested objects
        const processedParcels = tempParcel?.map(parcel => {
          const { geometry, ...rest } = parcel;
          
          // Process each field to handle nested objects
          const processed = {};
          for (let key in rest) {
            if (rest.hasOwnProperty(key)) {
              if (typeof rest[key] === 'object' && rest[key] !== null) {
                // Convert nested objects to string representation
                if (Array.isArray(rest[key])) {
                  processed[key] = rest[key].map(item => 
                    typeof item === 'object' ? JSON.stringify(item) : item
                  ).join(', ');
                } else {
                  // For objects like {fee, rate_type, currency}
                  const objValue = rest[key];
                  if (objValue.fee || objValue.rate_type || objValue.currency) {
                    processed[key] = `${objValue.fee || ''} ${objValue.currency || ''} (${objValue.rate_type || ''})`.trim();
                  } else {
                    processed[key] = JSON.stringify(objValue);
                  }
                }
              } else {
                processed[key] = rest[key];
              }
            }
          }
          return processed;
        });
        
        console.log("Processed parcels:", processedParcels);
        
        processedParcels && processedParcels?.length > 0
          ? setData(processedParcels)
          : setData([]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // useEffect to search for parcels at mounting time
  useEffect(() => {
    fetchParcelsInPark();
  }, []);

  if (loading) return <CircularProgress />;
  
  return (
    <>
      {console.log("KKKKKKKKKK", data)}
      {data && data?.length > 0 ? (
        <IPDCReportTemplate
          data={data}
          setData={setData}
          defaultTitle="Parcels List"
          isEditable={false}
          isPrintable={false}
          showWhatToDisplay={true}
        />
      ) : (
        <div>No Parcels Found</div>
      )}
    </>
  );
}